import React, { useState } from 'react';
import { DashboardWidget, WidgetScopeControl } from './DashboardWidgets';
import { TIME_SCOPES } from './timeScopes';
import { useScopedStatistics } from './useScopedStatistics';

// DJB-154: Most Played Artists leaderboard from the DJB-153 endpoint, re-queried
// whenever the time scope changes. The backend returns
// [{artistId, name, playCount}] ordered by combined plays desc, where playCount
// sums the plays of all the artist's tracks.
export const MostPlayedArtistsWidget = () => {
  const [scope, setScope] = useState('7d');
  const { data, loading, error } = useScopedStatistics('/statistics/artists/top-played?limit=25', scope);
  const artists = data || [];

  return (
    <DashboardWidget
      title="Most Played Artists"
      variant="long"
      className="most-played-artists-widget"
      // DJB-169: the time scope sits top-right in the title bar
      actions={
        <WidgetScopeControl
          label="Most played artists time scope"
          options={TIME_SCOPES}
          value={scope}
          onChange={setScope}
        />
      }
    >
      {error ? (
        <div className="widget-empty-note">Most played artists are unavailable right now.</div>
      ) : loading ? (
        <div className="widget-empty-note">Loading…</div>
      ) : artists.length === 0 ? (
        <div className="widget-empty-note">No plays in this period.</div>
      ) : (
        <ol className="widget-rows top-artists-list">
          {artists.map((artist, index) => (
            <li key={artist.artistId || index} className="widget-row top-artist-row">
              <span className="top-artist-rank">{index + 1}</span>
              <span className="widget-row-name">{artist.name}</span>
              <span className="widget-row-value">
                {artist.playCount} <span className="widget-pct">plays</span>
              </span>
            </li>
          ))}
        </ol>
      )}
    </DashboardWidget>
  );
};

export default MostPlayedArtistsWidget;
